import { QuestionType2UIConfig } from "../../../../../components/ui/question-type2-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import { scenario2NonAffiliatedStudentsAudioCaching, scenario2NonAffiliatedStudentsVideoSegments } from "../../../scenario2-non-affiliated-students";
import { NonAffiliatedStudentsComponentsStep2ComponentMainConfig, NonAffiliatedStudentsComponentsStep2ComponentPart1Config } from "../non-affiliated-students-components-step2";

export default class NonAffiliatedStudentsComponentsStep2Part1 extends BaseScenarioPart<GameBaseScenario> {

	private stepName="Step 3"
	private get config(): NonAffiliatedStudentsComponentsStep2ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: NonAffiliatedStudentsComponentsStep2ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType2UI({
			title: this.mainConfig.scenario.props.name,
			audioUrl: scenario2NonAffiliatedStudentsAudioCaching.getItemByKey(scenario2NonAffiliatedStudentsAudioCaching.audioKeys.question5).src,
			subtitle: this.stepName,
			isYesCorrect: true,
			correctFeedback: `
				<p class="default-text">Correct. There is a history involving this type of behavior or decision 
				making with this employee. You may consider the “repeated occurrences algorithm” in handling 
				the response with Chris in this event.</p>
			`,
			wrongFeedback: `
				<p class="default-text">Not the best option. There is a history involving this type of 
				behavior or decision making with this employee. The repetitive occurrences section of the 
				decision support tool should be reviewed and considered prior to making your decision.</p>
			`,
			question: 'Were there repetitive occurrences with this type of behavior involving the employee?',
			onSubmitClicked: (isCorrect: boolean, feedback: string, selectedTitle: string, parentQuestion: QuestionType2UIConfig) => {
				const mentorInfo = scenario2NonAffiliatedStudentsVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType2(isCorrect, feedback, selectedTitle, this.stepName, parentQuestion, () => {
					context.section2();
				}, () => {
					context.section2();
				}, undefined, undefined, process.env.PUBLIC_URL + '/assets/images/scenarios/step2-image.png', mentorInfo.src, mentorInfo.chapterIds[11], mentorInfo.chapterIds[12]);
			}
		}, 4);
	}

	public section2() {
		const context = this;
        this.mainConfig.scenario.setAreaForCurrentScenario(5);
		this.mainConfig.scenario.uiWrapper.displayIntroScreenUI({
			title: 'Re-Cap Summary Statement',
			subtitle: 'Scenario 2 - Non-Affiliated Students',
			recapFirst: 'In summary this is “Reckless Behavior.”',
			htmlData: `
				<br/><li>The substitution test is NOT satisfied. 
				<br/><br/></li><li>Accountability lies solely with the employee in this instance. 
				<br/><br/></li><li>Discipline may be warranted. Console and coach the employee. 
				<br/><br/></li><li>There is a history involving of this type of behavior with this employee. 
				<br/><br/></li><li>The repetitive behavior section of the DST should be reviewed prior to making your final decision.</li>
			`,
			okButton: 'Continue',
			onStartScenarioClicked: () => {
				context.onDone();
			},
			mentorUrl: scenario2NonAffiliatedStudentsVideoSegments.getItemByKey('Feedback').src,
			mentorChapter: scenario2NonAffiliatedStudentsVideoSegments.getItemByKey('Feedback').chapterIds[14]
		})
	}
}